import { forwardRef } from "react";

import Link from "next/link";

import { PropTypes } from "prop-types";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import NewselaLogo from "@/view/NewselaLogo";
import { linkCss } from "../Banner.style";

const propTypes = {
  ref: PropTypes.node,
};

const NewselaHomeLink = forwardRef((props, ref) => {
  return (
    <Link href={MONOLITH_ORIGIN} passHref legacyBehavior>
      <a css={linkCss} aria-label="Newsela Home" ref={ref}>
        <NewselaLogo />
      </a>
    </Link>
  );
});

NewselaHomeLink.propTypes = propTypes;

export default NewselaHomeLink;
